import { useState } from "react";
import { Loader2, PlayCircle } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const DetailsForm = ({ educationLevels, onStart, onMobileBlur, loading, submitLabel = "Start Assessment", subtitle = "We'll use these to issue your Assessment ID and discount." }) => {
  const [form, setForm] = useState({ name: "", age: "", mobile: "", email: "", education: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    onStart({ ...form, age: Number(form.age) });
  };

  return (
    <form onSubmit={submit} data-testid="assessment-details-form" className="bg-white border border-slate-200 rounded-3xl p-7 md:p-9 shadow-xl shadow-slate-200/50">
      <h2 className="font-heading text-2xl font-bold text-[#0A192F]">Your details</h2>
      <p className="text-sm text-[#64748B] mt-1">{subtitle}</p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <Label htmlFor="a-name">Student Name *</Label>
          <Input id="a-name" data-testid="assessment-name" value={form.name} onChange={set("name")} placeholder="Your full name" required minLength={2} className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="a-age">Age *</Label>
          <Input id="a-age" data-testid="assessment-age" type="number" min={5} max={100} value={form.age} onChange={set("age")} placeholder="e.g. 18" required className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="a-mobile">Mobile Number *</Label>
          <Input id="a-mobile" data-testid="assessment-mobile" type="tel" inputMode="numeric" value={form.mobile} onChange={set("mobile")} onBlur={() => onMobileBlur(form.mobile)} placeholder="10-digit mobile" required className="mt-1.5" />
        </div>
        <div className="md:col-span-2">
          <Label htmlFor="a-email">Email *</Label>
          <Input id="a-email" data-testid="assessment-email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" required className="mt-1.5" />
        </div>
        <div className="md:col-span-2">
          <Label>Education Level *</Label>
          <Select value={form.education} onValueChange={(v) => setForm((f) => ({ ...f, education: v }))}>
            <SelectTrigger data-testid="assessment-education" className="mt-1.5 h-10">
              <SelectValue placeholder="Select your education level" />
            </SelectTrigger>
            <SelectContent>
              {educationLevels.map((lvl) => (
                <SelectItem key={lvl} value={lvl} data-testid={`assessment-education-${lvl.replace(/\s+/g, "-").toLowerCase()}`}>{lvl}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <Button type="submit" disabled={loading} data-testid="assessment-start-btn" className="mt-7 w-full sm:w-auto bg-[#0A192F] hover:bg-[#0F2648] text-white font-semibold rounded-full h-12 px-8">
        {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <PlayCircle className="w-4 h-4 mr-2" />}
        {loading ? "Submitting..." : submitLabel}
      </Button>
    </form>
  );
};
